import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AssetSetGroup } from '../../shared/models/Recommendation/RecommendationInterfaces';

@Component({
  selector: 'md-portfolio-allocations-table',
  template: require('./portfolio-allocations-table.component.html'),
  styles: [require('./portfolio-allocations-table.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PortfolioAllocationsTableComponent {
  @Input() data: AssetSetGroup[];

}
